module.exports = __webpack_public_path__ + "static/media/Cheeseburger.5c221037.svg";